import { useTranslation } from 'react-i18next'

function useProvinceOptions() {
  const { t } = useTranslation()
  enum Province {
    Hebei = 'Hebei',
    Shanxi = 'Shanxi',
    Liaoning = 'Liaoning',
    Jilin = 'Jilin',
    Heilongjiang = 'Heilongjiang',
    Jiangsu = 'Jiangsu',
    Zhejiang = 'Zhejiang',
    Anhui = 'Anhui',
    Fujian = 'Fujian',
    Jiangxi = 'Jiangxi',
    Shandong = 'Shandong',
    Henan = 'Henan',
    Hubei = 'Hubei',
    Hunan = 'Hunan',
    Guangdong = 'Guangdong',
    Hainan = 'Hainan',
    Sichuan = 'Sichuan',
    Guizhou = 'Guizhou',
    Yunan = 'Yunan',
    Shaanxi = 'Shaanxi',
    Gansu = 'Gansu',
    Qinghai = 'Qinghai',
    Taiwan = 'Taiwan',
    Guangxi = 'Guangxi',
    Neimenggu = 'Neimenggu',
    Tibet = 'Tibet',
    Ningxia = 'Ningxia',
    Xinjiang = 'Xinjiang',
    Xianggang = 'Xianggang',
    AoMen = 'AoMen',
    Beijing = 'Beijing',
    Tianjin = 'Tianjin',
    Shanghai = 'Shanghai',
    Chongqing = 'Chongqing',
  }
  const PROVINCE_OPTIONS = [
    { value: Province.Anhui, label: t('i18n.province.Anhui') },
    { value: Province.AoMen, label: t('i18n.province.Macau') },
    { value: Province.Beijing, label: t('i18n.province.Beijing') },
    { value: Province.Chongqing, label: t('i18n.province.Chongqing') },
    { value: Province.Fujian, label: t('i18n.province.Fujian') },
    { value: Province.Gansu, label: t('i18n.province.Gansu') },
    { value: Province.Guangdong, label: t('i18n.province.Guangdong') },
    { value: Province.Guangxi, label: t('i18n.province.Guangxi') },
    { value: Province.Guizhou, label: t('i18n.province.Guizhou') },
    { value: Province.Hainan, label: t('i18n.province.Hainan') },
    { value: Province.Hebei, label: t('i18n.province.Hebei') },
    { value: Province.Heilongjiang, label: t('i18n.province.Heilongjiang') },
    { value: Province.Henan, label: t('i18n.province.Henan') },
    { value: Province.Hubei, label: t('i18n.province.Hubei') },
    { value: Province.Hunan, label: t('i18n.province.Hunan') },
    { value: Province.Jiangsu, label: t('i18n.province.Jiangsu') },
    { value: Province.Jiangxi, label: t('i18n.province.Jiangxi') },
    { value: Province.Jilin, label: t('i18n.province.Jilin') },
    { value: Province.Liaoning, label: t('i18n.province.Liaoning') },
    { value: Province.Neimenggu, label: t('i18n.province.Neimenggu') },
    { value: Province.Ningxia, label: t('i18n.province.Ningxia') },
    { value: Province.Qinghai, label: t('i18n.province.Qinghai') },
    { value: Province.Shaanxi, label: t('i18n.province.Shaanxi') },
    { value: Province.Shandong, label: t('i18n.province.Shandong') },
    { value: Province.Shanghai, label: t('i18n.province.Shanghai') },
    { value: Province.Shanxi, label: t('i18n.province.Shanxi') },
    { value: Province.Sichuan, label: t('i18n.province.Sichuan') },
    { value: Province.Taiwan, label: t('i18n.province.Taiwan') },
    { value: Province.Tianjin, label: t('i18n.province.Tianjin') },
    { value: Province.Tibet, label: t('i18n.province.Tibet') },
    { value: Province.Xianggang, label: t('i18n.province.HongKong') },
    { value: Province.Xinjiang, label: t('i18n.province.Xinjiang') },
    { value: Province.Yunan, label: t('i18n.province.Yunan') },
    { value: Province.Zhejiang, label: t('i18n.province.Zhejiang') },
  ]

  return {
    PROVINCE_OPTIONS,
  }
}

export default useProvinceOptions